<button
	class="chip-button"
	matTooltipClass="pv-tooltip"
	matTooltipPosition="right"
	[class.clickable]="clickable"
	[disabled]="disabled || loading"
	[matTooltip]="help"
	[matTooltipDisabled]="!help"
	(click)="action.emit()"
>
	@if (!loading) {
		<ng-content />
	} @else {
		<i class="fa fa-fw fa-spin fa-spinner"> </i>
	}
</button>
